import React, { Dispatch, SetStateAction } from 'react';
import { Helmet } from 'react-helmet-async';
import { Snippet } from '@distribute/shared/types';
import { useWindowWidth } from '@distribute/frontend/utils';
import { useUserAgentDevices } from '../../../../shared/hooks/useUserAgentDevices';
import { SnippetEditorHeader } from './SnippetEditorHeader';
import { SnippetEditorLeftSidebar } from './left-sidebar';
import { EDITOR_CONTAINER_ID } from '../../../../features/editor-left-sidebar/config';

type Props = {
  children: React.ReactNode;
  currentSnippet: Snippet;
  isSidebarOpen: boolean;
  setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
};

export const SnippetEditorWrapper: React.FC<Props> = ({
  children,
  currentSnippet,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const { isMobile } = useWindowWidth();
  const { isTablet } = useUserAgentDevices();

  return (
    <div className="relative flex flex-col h-screen overflow-y-hidden">
      <Helmet
        titleTemplate={`${currentSnippet?.name || 'Untitled'} - Distribute`}
      />

      <SnippetEditorHeader
        currentSnippet={currentSnippet}
        setIsSidebarOpen={setIsSidebarOpen}
        isSidebarOpen={isSidebarOpen}
      />
      <div className="flex gap-2 bg-gray-100 h-[calc(100vh-52px)] p-2 border-t border-base-black-4 justify-between">
        {!isMobile && !isTablet && <SnippetEditorLeftSidebar />}
        <div
          className="relative flex-grow flex flex-col overflow-hidden h-[calc(100vh-68px)] max-w-256"
          id={EDITOR_CONTAINER_ID}
        >
          <div className="flex-grow bg-base-white rounded-2xl h-[calc(100vh-68px)] overflow-y-auto border-base-black/[0.04] border">
            {children}
          </div>
        </div>
        <div className="w-20" />
      </div>
    </div>
  );
};
